import "./menuTop.css";
import Component from "react-pure-render/component";
import React from "react";
import { Link } from "react-router";
import Isvg from "react-inlinesvg";
import cookie from "cookie-dough";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import { clearAuthCookie } from "../../common/lib/auth";

import Breadcrumbs from "../components/breadcrumbs.react";

export default class MenuTop extends Component {
  static propTypes = {
    msg: React.PropTypes.object.isRequired,
    actions: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object
  };

  onLogout = e => {
    e.preventDefault();
    const { actions, notificationSystem } = this.props;
    actions.logout().then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
      }
    });

    clearAuthCookie(cookie);
    // Always reload app on logout for security reasons.
    window.location.href = "/logout";
  };

  openMenu = () => {
    const { actions } = this.props;
    actions.setSidebar("open", true);
  };

  render() {
    const {
      msg: { app: { menuTop: msg } },
      users: { currentUser },
      routes,
      settings
    } = this.props;

    return (
      <div className="col-xs-12 end-xs top-xs menu-top">
        <div className="box">
          <div className="row">
            <div className="col-xs-3 col-sm-2 start-xs top-xs menu-top visible-xs visible-sm">
              <div className="box">
                <div onClick={this.openMenu}>
                  <div className="menu-icon" />
                  <div className="menu-label">menu</div>
                </div>
              </div>
            </div>
            <div className="col-xs-9 col-sm-10 col-md-6 start-xs top-xs">
              <Breadcrumbs {...this.props} />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 end-xs top-xs menu-top">
              <div className="box">
                <nav>
                  <ul>
                    <li>
                      <Link to="/profile">
                        <Isvg
                          className="icon svg-middle"
                          src="/assets/img/icon_settings.svg"
                        />
                        {(currentUser && currentUser.email) || "ładowanie..."}
                      </Link>
                    </li>
                    <li>
                      <a href="#" onClick={this.onLogout}>
                        <Isvg
                          className="icon"
                          src="/assets/img/icon_signout.svg"
                        />
                        {msg.logout}
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/menuTop.react.js